import React from "react"
import { Button, ButtonLoader } from "../../../components/Button"
import { CheckBox, Label, TextArea } from "../../../components/Form"
import "./styles.scss"
import { sort } from "fast-sort"

const CheckListSection = ({
  values,
  onChange,
  checklist,
  showNewCheckListItem,
  closeTextAreaCheckList,
  handleAddItemCheckList,
  handleCreateCheckListItem,
  loadingChecklist,
  handleCheckListItem,
  checked,
}) => {
  const isEditing = showNewCheckListItem === checklist?.id

  return (
    <div className={`checklists-area checklist`}>
      <h5 className="text-box-only-visible add-value">
          {checklist?.name} {checklist?.items?.length > 0 && `(${checklist?.items?.length})`}
        </h5>

      {isEditing && (
        <>
          <TextArea
            isAutoScroll={true}
            isAutofocus={true}
            resize="none"
            value={values?.checkListItem || ""}
            onChange={(e) => onChange("checkListItem", e?.target?.value)}
          />
          <div className="planning-section-textarea-button">
            <Button color="orange" handleClick={() => closeTextAreaCheckList()} label="Cancelar" />
            <ButtonLoader
              color="orange"
              messageProcess="Salvando item"
              loading={loadingChecklist}
              handleClick={() => handleCreateCheckListItem(checklist?.id)}
              label="Salvar"
            />
          </div>
        </>
      )}

      {checklist?.items &&
        checklist?.items?.length > 0 &&
        sort(checklist?.items)
          .asc((f) => f.date)
          .map((item) => (
            <div className="checklist-area" key={item?.id}>
              <div className="checklist-area-checkbox">
                <div className="checklist-area-checkbox-text-box">
                  <CheckBox
                    label={item?.name}
                    type="checkbox"
                    value={`${item?.id}|${checklist?.id}`}
                    checked={checked?.some((val) => val === `${item?.id}|${checklist?.id}`)}
                    onChange={handleCheckListItem}
                  />
                </div>
              </div>
            </div>
          ))}
    </div>
  )
}

export const CheckListComponent = ({
  clickedCard,
  onChange,
  showNewCheckListItem,
  showNewCheckListItemItem,
  openEditCheckListTitleItem,
  handleAddItemCheckList,
  closeTextAreaCheckList,
  handleCreateCheckListItem,
  loadingChecklist,
  values,
  handleCheckListItem,
  checked,
}) => {
  return (
    <div className="planning-section-checklists">
      <h4>Checklists</h4>

      {clickedCard?.checklists.map((checklist) => (
        <CheckListSection
          {...{
            values,
            onChange,
            checklist,
            showNewCheckListItem,
            showNewCheckListItemItem,
            openEditCheckListTitleItem,
            closeTextAreaCheckList,
            handleAddItemCheckList,
            handleCreateCheckListItem,
            loadingChecklist,
            handleCheckListItem,
            checked,
          }}
        />
      ))}
    </div>
  )
}
